<section class="error-container">
      <img [src]="errorImage" alt="404" class="error-image">
</section>